import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { InjectedFormProps } from 'redux-form';
import { reduxForm, formValueSelector } from 'redux-form';

import type VendorVM from 'ab-viewModels/vendor/vendor.viewModel';

import type VendorRM from 'ab-requestModels/vendor/vendor.requestModel';

import type { RootState } from 'af-reducers';

import { VENDOR_EDIT } from 'af-constants/reduxForms';

import { validate } from './validate';
import Form from './VendorForm';

interface OwnProps {
	update: (form: VendorRM) => Promise<void>;
	toggleEdit: (id: Nullable<number>) => void;
	vendor: VendorVM;
	vendors: VendorVM[];
	id: Nullable<number>;
}

type Props = OwnProps & InjectedFormProps<VendorRM, OwnProps> & ConnectedProps<typeof connector>;

const VendorEdit: React.FC<Props> = (props: Props) => {
	const { vendor, toggleEdit, update, initialize, newName } = props;

	React.useEffect(() => {
		initialize(vendor);
		// do only on first render
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onUpdate = React.useCallback(async () => {
		await update({ name: newName });
		toggleEdit(null);
	}, [toggleEdit, update, newName]);

	const close = React.useCallback(() => {
		toggleEdit(null);
	}, [toggleEdit]);

	return (
		<Form {...props} close={close} formValue={newName} onSubmit={onUpdate} />
	);
};

function mapStateToProps(state: RootState) {
	return {
		newName: formValueSelector(VENDOR_EDIT)(state, 'name'),
	};
}

const connector = connect(mapStateToProps);

const enhance = compose<React.ComponentType<OwnProps>>(
	connector,
	reduxForm<VendorRM, OwnProps>({
		form: VENDOR_EDIT, validate, enableReinitialize: true,
	})
);

export default enhance(VendorEdit);
